import React, { Component } from 'react';
import PropTypes from 'prop-types';
import config from 'Config';
import api from 'Src/api';
import session from 'Src/session';

import FormProvider from 'Src/shared/form-provider';
import Contact from 'Src/shared/contact';
import Errors from 'Src/shared/errors';
const { Panel, PanelBody } = Contact;
// 「開始予約」のタイトル画像
import titleOpenImgUrl from 'Public/img/reservation-title-open.png';
import titleOpen2xImgUrl from 'Public/img/reservation-title-open@2x.png';
import titleOpenSpImgUrl from 'Public/img/sp-reservation-title-open.png';
import titleOpenSp2xImgUrl from 'Public/img/sp-reservation-title-open@2x.png';
// 「中止予約」のタイトル画像
import titleCloseImgUrl from 'Public/img/reservation-title-close.png';
import titleClose2xImgUrl from 'Public/img/reservation-title-close@2x.png';
import titleCloseSpImgUrl from 'Public/img/sp-reservation-title-close.png';
import titleCloseSp2xImgUrl from 'Public/img/sp-reservation-title-close@2x.png';
// 「給水区域内転居の場合」のタイトル画像
import titleMovingImgUrl from 'Public/img/reservation-title-moving.png';
import titleMoving2xImgUrl from 'Public/img/reservation-title-moving@2x.png';
import titleMovingSpImgUrl from 'Public/img/sp-reservation-title-moving.png';
import titleMovingSp2xImgUrl from 'Public/img/sp-reservation-title-moving@2x.png';
import {
  OpenDate,
  CloseDate,
  NextOpenDate,
  Customer,
  OpenInformation,
  PaymentMethod,
  OpenShipment,
  CloseShipment,
  Watertap,
  NextInformation,
  Payoff
  // CloseOpen
} from 'Src/components/form/block';
import ConfirmationModal from 'Src/shared/modal/confirmation';
const path = require('path');

const scrollTop = () => {
  window.scrollTo(0, 0);
};

class InputFormProvider extends FormProvider {
  static propTypes = {
    data:            PropTypes.object,
    reservationCode: PropTypes.string
  };
  isReference = false;
  constructor (props) {
    super(props);
    const self = this;
    self.state = self.state || {};
    self.state.page = self.inputPath;
    self.completeForm = self.completeForm.bind(self);
    self.submitForm = self.submitForm.bind(self);
    self.back = self.back.bind(self);
    if (props.data) {
      self.initialData = props.data;
    }
    if (self.isReference) {
      self.state.readonly = true;
    }
    // self.backFromReadonly = self.backFromReadonly.bind(self);
    window.onpopstate = (event) => {
      if (event.state) {
        self.setState(event.state);
      }
      setTimeout(scrollTop, 0);
    };
  }
  componentDidMount () {
    const self = this;
    if (super.componentDidMount) {
      super.componentDidMount();
    }
    // 個人情報取得に関する同意がされていない場合はトップへ戻る
    //  requiredAgreementKeyをセットしておくことで、トップでモーダルが自動で開く
    if (!session.isAgreed()) {
      session.requireAgreement(self.functionKey);
      window.history.replaceState(null, '', config.path.root);
      window.location.reload();
      // window.location.href = config.path.root;
      return;
    }
    // 確認画面がいきなり表示された場合、入力画面へ戻る
    if (!self.isReference) {
      const inputPath = self.props.reservationCode ? path.join(self.inputPath, self.props.reservationCode) : self.inputPath;
      const pageState = { page: inputPath, readonly: false };
      self.setState(pageState);
      window.history.replaceState(pageState, '', inputPath);
    }
    // 初期データ設定がある場合、投入
    if (self.initialData) {
      this.setFormData(self.initialData);
    }
  }
  componentDidUpdate (prevProps, prevState, snapshot) {
    const self = this;
    if (super.componentDidUpdate) {
      super.componentDidUpdate(prevProps, prevState, snapshot);
    }
    if (self.isReference && !self.state.readonly) {
      self.setState({ readonly: true });
    }
    // props.dataが遅延して渡された場合の対応
    if (self.props.data !== self.initialData) {
      self.initialData = self.props.data;
      this.setFormData(self.initialData);
    }
  }
  completeForm () {
    const self = this;
    if (self.state.apicalling) {
      return;
    }
    self
      .validate()
      .then((data) => {
        self.setState({ apicalling: true });
        return self.remoteValidate(data);
      })
      .then(() => {
        self.setState({ apicalling: false });
        const confirmPath = self.props.reservationCode ? path.join(self.confirmPath, self.props.reservationCode) : self.confirmPath;
        const pageState = { page: confirmPath, readonly: true, frozen: true };
        self.setState(pageState);
        window.history.pushState(pageState, '', confirmPath);
        scrollTop();
      })
      .catch(() => {
        self.setState({ apicalling: false });
        scrollTop();
      });
  }
  remoteValidate (requestData) {
    return api.validateReservation(requestData);
  }
  remoteSave (/* requestData */) {
    // サブクラスで実装
    throw new Error('method `remoteSave` must be implemented');
  }
  submitForm () {
    const self = this;
    if (self.state.apicalling) {
      return;
    }
    self
      .validate()
      .then((data) => {
        self.setState({ apicalling: true });
        return self.remoteSave(data);
      })
      .then((savedResponse) => {
        if (savedResponse && savedResponse.reservationCode) {
          session.setReservationCode(savedResponse.reservationCode);
        }
        self.setState({ apicalling: false });
        const pageState = { page: self.completePath, readonly: true, frozen: true };
        window.history.replaceState(pageState, '', self.completePath);
        window.location.reload();
        scrollTop();
      })
      .catch((error) => {
        self.setState({ apicalling: false });
        // TODO 保存失敗時の挙動
        console.error(error);
        scrollTop();
      });
  }
  sortByName (items) {
    const self = this;
    if (!self.properties) {
      return items;
    }
    const names = Object.keys(self.properties)
      .map((k) => self.properties[k].name)
      .filter((v) => v);
    items.sort((a, b) => {
      return names.indexOf(a.name) - names.indexOf(b.name);
    });
    return items;
  }
  back () {
    window.history.back();
  }
  // backFromReadonly () {
  //   const self = this;
  //   if (self.state.page !== self.inputPath) {
  //     window.history.back();
  //   }
  // }
}

const properties = config.form_properties;
const openProperties = Object.keys(properties).reduce((result, k) => {
  if (/open/.test(properties[k].func)) {
    result[k] = properties[k];
  }
  return result;
}, {});
const closeProperties = Object.keys(properties).reduce((result, k) => {
  if (/close/.test(properties[k].func)) {
    result[k] = properties[k];
  }
  return result;
}, {});

class Open extends InputFormProvider {
  functionKey = config.functions.open;
  inputPath = config.path.open;
  confirmPath = config.path.open_confirm;
  completePath = config.path.open_complete;
  initialData = config.openInitialData;
  properties = openProperties;
  constructor (props) {
    super(props);
    const self = this;
    self.openDateRef = React.createRef();
  }
  componentDidMount () {
    const self = this;
    if (super.componentDidMount) {
      super.componentDidMount();
    }
    self.form.set('reservationType', 'open');
    if (self.openDateRef.current) {
      self.openDateRef.current.getRangeText().then((text) => {
        self.setState({ openDateRange: text });
      });
    }
  }
  componentDidUpdate (prevProps, prevState, snapshot) {
    const self = this;
    if (super.componentDidUpdate) {
      super.componentDidUpdate(prevProps, prevState, snapshot);
    }
    if (!self.state.openDateRange && self.openDateRef.current) {
      self.openDateRef.current.getRangeText().then((text) => {
        self.setState({ openDateRange: text });
      });
    }
  }
  renderForm () {
    const self = this;
    const { errors, readonly } = self.state;
    return (
      <Contact theme="positive" readonly={readonly}>
        <div className="mb-3">
          <picture>
            <source srcSet={`${titleOpenSpImgUrl} 1x, ${titleOpenSp2xImgUrl} 2x`} media="(max-width: 575px)" />
            <img
              src={titleOpenImgUrl}
              srcSet={`${titleOpenImgUrl} 1x, ${titleOpen2xImgUrl} 2x`}
              alt="水道使用 開始予約 インターネット受付"
              className="img-fluid w-100"
            />
          </picture>
        </div>
        {readonly && !self.isReference && (
          <div>
            <div className="h3 text-center text-danger font-weight-bold font-weight-bold">{self.attentionText}</div>
            <div className="h4 text-center">{self.stepText}</div>
          </div>
        )}
        {errors && errors.length >= 1 && <Errors errors={errors} />}
        {!self.isReference && self.state.openDateRange && (
          <p className="text-md-center">
            予約可能なご使用開始日付は、
            <strong className="text-danger">{self.state.openDateRange}</strong>
            です。
          </p>
        )}
        <Panel title="使用開始日" theme="default">
          <OpenDate wrappedComponentRef={self.openDateRef} />
        </Panel>
        <Panel title="ご使用者／メールアドレス／電話番号" theme="secondary">
          <Customer />
        </Panel>
        <Panel title="ご使用の住所（入居先の住所）／電話番号" theme="primary">
          <OpenInformation />
        </Panel>
        <Panel title="料金支払方法" theme="secondary">
          <PaymentMethod />
        </Panel>
        <Panel
          title={`納付書等発送先（納付書等の発送先が入居先と違う場合${
            !readonly ? '、以下の入力を行ってください' : ''
          }）`}
          theme="optional"
        >
          <OpenShipment />
        </Panel>
        {self.renderFoot()}
      </Contact>
    );
  }
}

class Close extends InputFormProvider {
  inputPath = config.path.close;
  functionKey = config.functions.close;
  confirmPath = config.path.close_confirm;
  completePath = config.path.close_complete;
  initialData = config.closeInitialData;
  properties = closeProperties;
  constructor (props) {
    super(props);
    const self = this;
    self.state = self.state || {};
    self.closeDateRef = React.createRef();
    self.nextOpenDateRef = React.createRef();
    self.toggleCloseOpen = self.toggleCloseOpen.bind(self);
  }
  componentDidMount () {
    const self = this;
    if (super.componentDidMount) {
      super.componentDidMount();
    }
    self.form.set('reservationType', 'close');
    if (self.closeDateRef.current) {
      self.closeDateRef.current.getRangeText().then((text) => {
        self.setState({ closeDateRange: text });
      });
    }
    if (self.nextOpenDateRef.current) {
      self.nextOpenDateRef.current.getRangeText().then((text) => {
        self.setState({ nextOpenDateRange: text });
      });
    }
  }
  componentDidUpdate (prevProps, prevState, snapshot) {
    const self = this;
    if (super.componentDidUpdate) {
      super.componentDidUpdate(prevProps, prevState, snapshot);
    }
    if (!self.state.closeDateRange && self.closeDateRef.current) {
      self.closeDateRef.current.getRangeText().then((text) => {
        self.setState({ closeDateRange: text });
      });
    }
    if (!self.state.nextOpenDateRange && self.nextOpenDateRef.current) {
      self.nextOpenDateRef.current.getRangeText().then((text) => {
        self.setState({ nextOpenDateRange: text });
      });
    }
  }
  toggleCloseOpen () {
    const self = this;
    const newVal = !self.form.get('closeOpen');
    self.form.set('closeOpen', newVal ? 1 : null);
  }
  renderForm () {
    const self = this;
    const { errors, readonly } = self.state;
    const closeOpen = Boolean(self.form.get('closeOpen'));
    return (
      <Contact theme="positive" readonly={readonly}>
        <div className="mb-3">
          <picture>
            <source srcSet={`${titleCloseSpImgUrl} 1x, ${titleCloseSp2xImgUrl} 2x`} media="(max-width: 575px)" />
            <img
              src={titleCloseImgUrl}
              srcSet={`${titleCloseImgUrl} 1x, ${titleClose2xImgUrl} 2x`}
              alt="水道使用 中止予約 インターネット受付"
              className="img-fluid w-100"
            />
          </picture>
        </div>
        {readonly && !self.isReference && (
          <div>
            <div className="h3 text-center text-danger font-weight-bold">{self.attentionText}</div>
            <div className="h4 text-center">{self.stepText}</div>
          </div>
        )}
        {errors && errors.length >= 1 && <Errors errors={errors} />}
        {!self.isReference && self.state.closeDateRange && (
          <p className="text-md-center">
            予約可能なご使用中止日付は、
            <strong className="text-danger">{self.state.closeDateRange}</strong>
            です。
          </p>
        )}
        <Panel title="使用中止日" theme="default">
          <CloseDate wrappedComponentRef={self.closeDateRef} />
        </Panel>
        <Panel title="お客様番号" theme="default">
          <Watertap />
        </Panel>
        <Panel title="ご使用者／メールアドレス／電話番号" theme="secondary">
          <Customer />
        </Panel>
        <Panel title="精算方法" theme="default">
          <Payoff />
        </Panel>
        <Panel title="転居先の住所／電話番号" theme="primary">
          <NextInformation />
        </Panel>
        {(closeOpen || !readonly) && (
          <div className="closeOpen border border-negative mb-3">
            <picture>
              <source srcSet={`${titleMovingSpImgUrl} 1x, ${titleMovingSp2xImgUrl} 2x`} media="(max-width: 575px)" />
              <img
                src={titleMovingImgUrl}
                srcSet={`${titleMovingImgUrl} 1x, ${titleMoving2xImgUrl} 2x`}
                alt="給水区域内転居の場合"
                className="img-fluid w-100"
              />
            </picture>
            <div className="closeOpenContent">
              {closeOpen ? (
                <div className="mt-3">
                  {!self.isReference && self.state.nextOpenDateRange && (
                    <p className="text-md-center">
                      予約可能なご使用開始日付は、
                      <strong className="text-danger">{self.state.nextOpenDateRange}</strong>
                      です。
                    </p>
                  )}
                  <Panel title="使用開始日" theme="default">
                    <NextOpenDate wrappedComponentRef={self.nextOpenDateRef} />
                  </Panel>
                  <Panel title="料金支払方法" theme="secondary" mb={readonly ? 0 : 2}>
                    <PaymentMethod skipWatertapInput={true} />
                  </Panel>
                  {!readonly && (
                    <div className="btn-toolbar justify-content-start p-2">
                      <button
                        type="button"
                        onClick={self.toggleCloseOpen}
                        className="btn btn-secondary px-md-5"
                        tabIndex={-1}
                      >
                        <strong>ご使用開始 お申込みの取消</strong>
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <Panel theme="default">
                    <PanelBody>
                      <p className="text-lg-center mb-0">
                        転居先が給水区域内（豊明市、日進市、みよし市、長久手市、東郷町）のお客さまで、
                        <br />
                        転居先の水道のご使用開始日がお決まりの場合は、以下のボタンを押し、引き続き入力をお願いします。
                      </p>
                    </PanelBody>
                  </Panel>
                  <div className="btn-toolbar justify-content-center my-3">
                    <button className="btn btn-primary px-5" onClick={self.toggleCloseOpen}>
                      <strong>ご使用開始のお申込み</strong>
                    </button>
                  </div>
                  <Panel theme="primary" mb={0}>
                    <PanelBody>
                      <p className="text-lg-center mb-0">
                        転居先が給水区域内（豊明市、日進市、みよし市、長久手市、東郷町）のお客さまでも、
                        <br />
                        転居先の水道のご使用開始日が
                        <span className="font-weight-bold text-danger">未定（水道使用中止のみ）</span>の場合は、最下部の
                        <span className="font-weight-bold text-danger">内容確認ボタン</span>を押してください。
                      </p>
                    </PanelBody>
                  </Panel>
                </div>
              )}
            </div>
          </div>
        )}
        <Panel
          title={`納付書等発送先（納付書等の発送先が転居先と違う場合${
            !readonly ? '、以下の入力を行ってください' : ''
          }）`}
          theme="optional"
        >
          <CloseShipment />
        </Panel>
        {self.renderFoot()}
      </Contact>
    );
  }
}

export class OpenInput extends Open {
  isReference = false;
  attentionText = '予約は完了しておりません';
  stepText = '予約内容確認';
  remoteSave (requestData) {
    return api.createReservation(requestData);
  }
  renderFoot () {
    const self = this;
    return (
      <div>
        {self.state.readonly ? (
          <div>
            <p className="mb-0 text-danger text-right px-2">予約内容をメールで送信します</p>
            <div className="btn-toolbar justify-content-between p-2">
              <button type="button" onClick={self.back} className="btn btn-secondary px-md-5" tabIndex={-1}>
                <strong>内容訂正</strong>
              </button>
              <button
                type="button"
                onClick={self.submitForm}
                className="btn btn-primary px-md-5"
                disabled={Boolean(self.state.apicalling)}
              >
                <strong>開始予約をする</strong>
              </button>
            </div>
          </div>
        ) : (
          <div className="btn-toolbar justify-content-between p-2">
            <button type="button" onClick={self.back} className="btn btn-secondary px-md-5" tabIndex={-1}>
              <strong>キャンセル</strong>
            </button>
            <button
              type="button"
              onClick={self.completeForm}
              className="btn btn-primary px-md-5"
              disabled={Boolean(self.state.apicalling)}
            >
              <strong>内容確認</strong>
            </button>
          </div>
        )}
      </div>
    );
  }
}
export class CloseInput extends Close {
  isReference = false;
  attentionText = '予約は完了しておりません';
  stepText = '予約内容確認';
  remoteSave (requestData) {
    return api.createReservation(requestData);
  }
  renderFoot () {
    const self = this;
    return (
      <div>
        {self.state.readonly ? (
          <div>
            <p className="mb-0 text-danger text-right px-2">予約内容をメールで送信します</p>
            <div className="btn-toolbar justify-content-between p-2">
              <button type="button" onClick={self.back} className="btn btn-secondary px-md-5" tabIndex={-1}>
                <strong>内容訂正</strong>
              </button>
              <button
                type="button"
                onClick={self.submitForm}
                className="btn btn-primary px-md-5"
                disabled={Boolean(self.state.apicalling)}
              >
                <strong>中止予約をする</strong>
              </button>
            </div>
          </div>
        ) : (
          <div className="btn-toolbar justify-content-between p-2">
            <button type="button" onClick={self.back} className="btn btn-secondary px-md-5" tabIndex={-1}>
              <strong>キャンセル</strong>
            </button>
            <button
              type="button"
              onClick={self.completeForm}
              className="btn btn-primary px-md-5"
              disabled={Boolean(self.state.apicalling)}
            >
              <strong>内容確認</strong>
            </button>
          </div>
        )}
      </div>
    );
  }
}

class OpenChange extends Open {
  static propTypes = Object.assign({}, Open.propTypes, { remoteChange: PropTypes.func.isRequired });
  inputPath = config.path.change;
  functionKey = config.functions.reference;
  confirmPath = config.path.change_confirm;
  completePath = config.path.change_complete;
  initialData = null;
  isReference = false;
  attentionText = '変更は完了しておりません';
  stepText = '変更内容確認';
  remoteSave (requestData) {
    const self = this;
    return self.props.remoteChange(requestData);
  }
  renderFoot () {
    const self = this;
    return (
      <div>
        {self.state.readonly ? (
          <div>
            <p className="mb-0 text-danger text-right px-2">変更内容をメールで送信します</p>
            <div className="btn-toolbar justify-content-between p-2">
              <button type="button" onClick={self.back} className="btn btn-secondary px-md-5" tabIndex={-1}>
                <strong>内容訂正</strong>
              </button>
              <button
                type="button"
                onClick={self.submitForm}
                className="btn btn-primary px-md-5"
                disabled={Boolean(self.state.apicalling)}
              >
                <strong>予約を変更する</strong>
              </button>
            </div>
          </div>
        ) : (
          <div className="btn-toolbar justify-content-between p-2">
            <button type="button" onClick={self.back} className="btn btn-secondary px-md-5" tabIndex={-1}>
              <strong>キャンセル</strong>
            </button>
            <button
              type="button"
              onClick={self.completeForm}
              className="btn btn-primary px-md-5"
              disabled={Boolean(self.state.apicalling)}
            >
              <strong>内容確認</strong>
            </button>
          </div>
        )}
      </div>
    );
  }
}
class CloseChange extends Close {
  static propTypes = Object.assign({}, Open.propTypes, { remoteChange: PropTypes.func.isRequired });
  inputPath = config.path.change;
  functionKey = config.functions.reference;
  confirmPath = config.path.change_confirm;
  completePath = config.path.change_complete;
  initialData = null;
  isReference = false;
  attentionText = '変更は完了しておりません';
  stepText = '変更内容確認';
  remoteSave (requestData) {
    const self = this;
    return self.props.remoteChange(requestData);
  }
  renderFoot () {
    const self = this;
    return (
      <div>
        {self.state.readonly ? (
          <div>
            <p className="mb-0 text-danger text-right px-2">変更内容をメールで送信します</p>
            <div className="btn-toolbar justify-content-between p-2">
              <button type="button" onClick={self.back} className="btn btn-secondary px-md-5" tabIndex={-1}>
                <strong>内容訂正</strong>
              </button>
              <button
                type="button"
                onClick={self.submitForm}
                className="btn btn-primary px-md-5"
                disabled={Boolean(self.state.apicalling)}
              >
                <strong>予約を変更する</strong>
              </button>
            </div>
          </div>
        ) : (
          <div className="btn-toolbar justify-content-between p-2">
            <button type="button" onClick={self.back} className="btn btn-secondary px-md-5" tabIndex={-1}>
              <strong>キャンセル</strong>
            </button>
            <button
              type="button"
              onClick={self.completeForm}
              className="btn btn-primary px-md-5"
              disabled={Boolean(self.state.apicalling)}
            >
              <strong>内容確認</strong>
            </button>
          </div>
        )}
      </div>
    );
  }
}

class OpenReference extends Open {
  isReference = true;
  initialData = null;
  back () {
    window.location.href = config.path.root;
  }
  renderFoot () {
    const self = this;
    return (
      <div>
        <div className="btn-toolbar justify-content-start p-2">
          <button type="button" onClick={self.back} className="btn btn-secondary px-md-5 mr-auto" tabIndex={-1}>
            <strong>終了</strong>
          </button>
          {self.props.delete && (
            <button type="button" onClick={self.props.delete} className="btn btn-secondary px-md-5 mr-2">
              <strong>予約を取消</strong>
            </button>
          )}
          {self.props.change && (
            <button type="button" onClick={self.props.change} className="btn btn-primary px-md-5">
              <strong>予約を変更</strong>
            </button>
          )}
        </div>
      </div>
    );
  }
}
class CloseReference extends Close {
  isReference = true;
  initialData = null;
  back () {
    window.location.href = config.path.root;
  }
  renderFoot () {
    const self = this;
    return (
      <div>
        <div className="btn-toolbar justify-content-start p-2">
          <button type="button" onClick={self.back} className="btn btn-secondary px-md-5 mr-auto" tabIndex={-1}>
            <strong>終了</strong>
          </button>
          {self.props.delete && (
            <button type="button" onClick={self.props.delete} className="btn btn-secondary px-md-5 mr-2">
              <strong>予約を取消</strong>
            </button>
          )}
          {self.props.change && (
            <button type="button" onClick={self.props.change} className="btn btn-primary px-md-5">
              <strong>予約を変更</strong>
            </button>
          )}
        </div>
      </div>
    );
  }
}

/**
 * @this Component
 * @return {Promise} 取得した予約データのPromise
 */
const fetchReservationData = function () {
  const self = this;
  const { token, reservationCode } = session.getCertificate();
  return api.getReservation({ token, reservationCode }).then((reservation) => {
    const data = reservation;
    self.setState({ data });
    resolve(data);
  });
  // catchは呼び出し元で定義
};

/**
 * 照会
 */
export class Reference extends Component {
  constructor (props) {
    super(props);
    const self = this;
    self.state = {
      data:            null,
      deleting:        false,
      cannotOperation: null
    };
  }
  componentDidMount () {
    const self = this;
    const { token, reservationCode } = session.getCertificate();
    // 予約番号に関する認証情報がない場合は、認証画面へ戻る
    if (!token || !reservationCode) {
      session.removeCertificate();
      window.history.replaceState(null, '', config.path.reference_certificate);
      window.location.reload();
      return;
    }
    self.setState({ token, reservationCode });
    self.fetchData().catch(() => {
      // TODO 取得失敗した旨のエラー表示を行い、認証画面へのリンクを表示する
    });
  }
  fetchData () {
    const self = this;
    return fetchReservationData.call(self);
  }
  delete () {
    const self = this;
    const { data } = self.state;
    if (data.printed) {
      self.setState({ cannotOperation: '取消' });
      return;
    }
    self.setState({ deleting: true });
  }
  remoteDelete () {
    const self = this;
    const { token, reservationCode, data } = self.state;
    if (!data || !token || !reservationCode) {
      return;
    }
    api
      .deleteReservation({ reservationCode, token })
      .then(() => {
        window.history.replaceState(null, '', config.path.cancel_complete);
        window.location.reload();
        scrollTop();
      })
      .catch(() => {
        // TODO 失敗時処理
        // 処理済みである場合（ダイアログ表示後に処理済みになった）
        // self.setState({ cannotOperation: '取消' });
        // 認証情報の消失
        // 偶発的なサーバーエラー
      });
  }
  change () {
    const self = this;
    const { token, reservationCode, data } = self.state;
    if (!data || !token || !reservationCode) {
      return;
    }
    if (data.printed) {
      self.setState({ cannotOperation: '変更' });
      return;
    }
    window.location.href = path.join(config.path.change, reservationCode);
  }
  render () {
    const self = this;
    const { data, reservationCode } = self.state;
    if (!data) {
      return null;
    }
    const childProps = {
      data,
      reservationCode,
      delete: self.delete.bind(self),
      change: self.change.bind(self)
    };
    let reference = null;
    if (String(data.reservationType) === 'open') {
      reference = <OpenReference {...childProps} />;
    } else if (String(data.reservationType) === 'close') {
      reference = <CloseReference {...childProps} />;
    }
    return (
      <div>
        {reference}
        {self.state.deleting && (
          <ConfirmationModal
            title="予約の取消"
            onExited={() => self.setState({ deleting: false })}
            onConfirm={() => {
              self.remoteDelete();
            }}
            checkText="この予約を取り消します。"
            cancelButton={false}
            submitButton="OK"
            autoClose
          />
        )}
        {self.state.cannotOperation && (
          <ConfirmationModal
            title={`予約の${self.state.cannotOperation}`}
            onExited={() => self.setState({ cannotOperation: null })}
            onConfirm={() => {
              // do nothing
            }}
            cancelButton={false}
            submitButton="OK"
            autoClose
          >
            <p>{self.state.cannotOperation}できませんのでお電話でお問い合わせください</p>
            <p>
              <a href="tel:0561370141" className="font-weight-bold text-dark">
                0561-37-0141（使用開始中止受付ダイヤル）
              </a>
            </p>
          </ConfirmationModal>
        )}
      </div>
    );
  }
}

/**
 * 変更
 */
export class Change extends Component {
  constructor (props) {
    super(props);
    const self = this;
    self.state = {};
  }
  componentDidMount () {
    const self = this;
    const { token, reservationCode } = session.getCertificate();
    // 予約番号に関する認証情報がない場合は、認証画面へ戻る
    if (!token || !reservationCode) {
      session.removeCertificate();
      window.history.replaceState(null, '', config.path.reference_certificate);
      window.location.reload();
      return;
    }
    self.setState({ token, reservationCode });
    self.fetchData().catch(() => {
      // TODO 予約情報 取得失敗した旨のエラー表示を行い、認証画面へのリンクを表示する
    });
  }
  fetchData () {
    const self = this;
    return fetchReservationData.call(self);
  }
  remoteChange (requestData) {
    const self = this;
    const { token, reservationCode } = self.state;
    requestData.token = token;
    requestData.reservationCode = reservationCode;
    return api.changeReservation(requestData);
    // .catch(() => {
    //   // TODO 予約変更 失敗時処理 原因によって処理を切り替える
    //   // 処理済みである場合（ダイアログ表示後に処理済みになった）
    //   // self.setState({ cannotOperation: '変更' });
    //   // 認証情報の消失
    //   // 偶発的なサーバーエラー
    // });
  }
  render () {
    const self = this;
    const { data, reservationCode } = self.state;
    if (!data) {
      return null;
    }
    const childProps = {
      data,
      reservationCode,
      remoteChange: self.remoteChange.bind(self)
    };
    let reference = null;
    if (String(data.reservationType) === 'open') {
      reference = <OpenChange {...childProps} />;
    } else if (String(data.reservationType) === 'close') {
      reference = <CloseChange {...childProps} />;
    }
    return (
      <div>
        {reference}
        {self.state.cannotOperation && (
          <ConfirmationModal
            title={`予約の${self.state.cannotOperation}`}
            onExited={() => self.setState({ cannotOperation: null })}
            onConfirm={() => {
              // do nothing
            }}
            cancelButton={false}
            submitButton="OK"
            autoClose
          >
            <p>{self.state.cannotOperation}できませんのでお電話でお問い合わせください</p>
            <p>
              <a href="tel:0561370141" className="font-weight-bold text-dark">
                0561-37-0141（使用開始中止受付ダイヤル）
              </a>
            </p>
          </ConfirmationModal>
        )}
      </div>
    );
  }
}
